export default "__VITE_ASSET__C6rFal_9__"